import { DEFAULT_ROWS_PER_PAGE } from '@crema/constants';
import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { REHYDRATE } from 'redux-persist';
import { axiosBaseQuery } from './baseQuery';

export const paperGroupApi = createApi({
  reducerPath: 'paperGroup.api',
  baseQuery: axiosBaseQuery,
  // https://stackoverflow.com/questions/72687628/cannot-read-properties-of-undefined-reading-api-reducerpath-at-object-extrac
  extractRehydrationInfo(action, { reducerPath }) {
    if (action.type === REHYDRATE) {
      return action.payload?.[reducerPath];
    }
  },
  tagTypes: ['paperGroup'],
  endpoints: (builder) => ({
    getPaperGroup: builder.query({
      query: ({ pageNo = 0, pageSize = DEFAULT_ROWS_PER_PAGE, name = '' }) => ({
        url: `/api/paper-groups?pageNo=${pageNo}&pageSize=${pageSize}&name=${name}`,
      }),
      transformResponse: (response, meta: any) => {
        return {
          rows: response,
          totalCount: meta.totalCount,
        };
      },
      keepUnusedDataFor: 5,
      providesTags: ['paperGroup'],
    }),
    getPaperGroupById: builder.query({
      query: (id) => ({
        url: `/api/paper-groups/${id}`,
        method: 'GET',
      }),
      providesTags: ['paperGroup'],
    }),
    updatePaperGroup: builder.mutation({
      query: (body) => ({
        url: `/api/paper-groups/${body.id}`,
        method: 'PUT',
        body,
      }),
      invalidatesTags: ['paperGroup'],
    }),
    addPaperGroup: builder.mutation({
      query: (body) => ({
        url: '/api/paper-groups',
        method: 'POST',
        body,
      }),
      invalidatesTags: ['paperGroup'],
    }),
    deletePaperGroup: builder.mutation({
      query: (id) => ({
        url: `/api/paper-groups/${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['paperGroup'],
    }),
  }),
});

export const {
  useAddPaperGroupMutation,
  useDeletePaperGroupMutation,
  useGetPaperGroupQuery,
  useUpdatePaperGroupMutation,
  useGetPaperGroupByIdQuery,
} = paperGroupApi;
